import { useEffect, useState } from 'react'

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://visiontec-e7e483e8d6db.herokuapp.com').replace(/\/$/, '')

// El servidor no filtra JSON por clave: se traen los productos con `attributes` y se filtra pro_seleccion aquí.
const QUERY = `
  query ProSelectionProducts {
    products(filters: { attributes: { notNull: true } }, pagination: { limit: 200 }) {
      documentId
      nombre
      descripcion
      codigo
      brand { name }
      imagen { url }
      attributes
    }
  }
`

const RESERVED = /^(pro_seleccion|homologado_swrya|nivel_pro_selection|operacion_pro_selection|diferenciador_pro_selection|ficha_tecnica_url|familia|categoria|accesorio_\d+)$/

const isTrue = (v) => v === true || v === 'true' || v === 'Sí' || v === 'Si'
const label = (key) => key.charAt(0).toUpperCase() + key.slice(1)
const absolute = (url) => (!url ? null : /^https?:/.test(url) ? url : `${BACKEND_URL}${url}`)

function normalize(p) {
  const a = p.attributes || {}
  const level = Number((String(a.nivel_pro_selection || '').match(/\d/) || [])[0]) || null
  return {
    id: p.documentId,
    codigo: p.codigo,
    nombre: p.nombre,
    marca: p.brand?.name || '',
    descripcion: p.descripcion || '',
    imagen: absolute(p.imagen?.[0]?.url),
    operacion: a.operacion_pro_selection || '',
    level,
    swrya: isTrue(a.homologado_swrya),
    diff: a.diferenciador_pro_selection || '',
    fichaUrl: a.ficha_tecnica_url || null,
    familia: a.familia || '',
    categoria: a.categoria || '',
    accesorios: Object.keys(a)
      .filter((k) => /^accesorio_\d+$/.test(k))
      .sort((x, y) => parseInt(x.split('_')[1], 10) - parseInt(y.split('_')[1], 10))
      .map((k) => a[k]),
    specs: Object.entries(a)
      .filter(([k, v]) => !RESERVED.test(k) && v !== null && typeof v !== 'object')
      .map(([k, v]) => [label(k), String(v)]),
  }
}

let cache = null

export function fetchProSelection() {
  if (!cache) {
    cache = fetch(`${BACKEND_URL}/graphql`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: QUERY }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return res.json()
      })
      .then((json) => {
        if (json.errors) throw new Error(json.errors[0]?.message || 'GraphQL error')
        return json.data.products.filter((p) => isTrue(p.attributes?.pro_seleccion)).map(normalize)
      })
      .catch((err) => {
        cache = null // permite reintentar
        throw err
      })
  }
  return cache
}

export function useProSelection() {
  const [state, setState] = useState({ products: [], loading: true, error: null })
  useEffect(() => {
    let alive = true
    fetchProSelection()
      .then((products) => alive && setState({ products, loading: false, error: null }))
      .catch((error) => alive && setState({ products: [], loading: false, error }))
    return () => { alive = false }
  }, [])
  return state
}
